import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSentry } from './lib/sentry';

// Initialize Sentry error logging as early as possible (FR38)
// Set VITE_SENTRY_DSN in .env.local to enable error tracking
initSentry(import.meta.env.VITE_SENTRY_DSN);

// One-time cleanup: remove legacy onboarding localStorage (Epic 17 Story 17.6)
// TODO: Remove after 2026-06
if (localStorage.getItem('sagamoon-onboarding')) {
  localStorage.removeItem('sagamoon-onboarding');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
